import React, { Fragment, useState, useEffect } from 'react';
import { Typography } from '@mui/material';

import { useTypedSelector } from '../../../redux';
import { ModeType } from '../../../helpers/enums';
import PreferenceCard from '../preferenceCard';
import ModeTypeTabs from '../../tabs/modeTypeTabs';
import TrackingLostRule from './trackingLostRule';

const TrackingLostRuleCard = ({
    handleIsCardValidChange
}: {
    handleIsCardValidChange: (isValid: boolean) => void;
}): JSX.Element => {
    const organizationEditablePreferences = useTypedSelector((state) => { return state.organization.organizationEditablePreferences; });

    const [currentTab, setCurrentTab] = useState<ModeType>(ModeType.Truckload);
    const [isTruckloadRuleValid, setIsTruckloadRuleValid] = useState(true);
    const [isLTLRuleValid, setIsLTLRuleValid] = useState(true);
    const [isParcelRuleValid, setIsParcelRuleValid] = useState(true);
    const [isRailRuleValid, setIsRailRuleValid] = useState(true);
    const [isOceanRuleValid, setIsOceanRuleValid] = useState(true);
    const [isUnknownRuleValid, setIsUnknownRuleValid] = useState(true);

    useEffect((): void => {
        const isCardValid =
            isTruckloadRuleValid &&
            isLTLRuleValid &&
            isParcelRuleValid &&
            isRailRuleValid &&
            isOceanRuleValid &&
            isUnknownRuleValid;
        handleIsCardValidChange(isCardValid);
    }, [
        handleIsCardValidChange,
        isTruckloadRuleValid,
        isLTLRuleValid,
        isParcelRuleValid,
        isRailRuleValid,
        isOceanRuleValid,
        isUnknownRuleValid
    ]);

    const handleTabChange = (newValue: ModeType): void => {
        setCurrentTab(newValue);
    };

    const handleIsRuleValidChange = (modeType: ModeType, isValid: boolean): void => {
        switch (modeType) {
            case ModeType.Truckload: {
                setIsTruckloadRuleValid(isValid);
                break;
            }
            case ModeType.LTL: {
                setIsLTLRuleValid(isValid);
                break;
            }
            case ModeType.Parcel: {
                setIsParcelRuleValid(isValid);
                break;
            }
            case ModeType.Rail: {
                setIsRailRuleValid(isValid);
                break;
            }
            case ModeType.Ocean: {
                setIsOceanRuleValid(isValid);
                break;
            }
            case ModeType.Unknown: {
                setIsUnknownRuleValid(isValid);
                break;
            }
            default:
                // default case will never get hit
                console.error(`${modeType} currently not supported in trackingLostRuleCard validation.`);
                break;
        }
    };

    const renderTrackingLostRule = (): JSX.Element => {
        const rulesForModeType = organizationEditablePreferences.freightPortalPreferencesOnTimeRules
            .find((item): boolean => {
                return item.modeType === currentTab;
            });

        if (rulesForModeType) {
            return (
                <TrackingLostRule
                    selectedModeType={currentTab}
                    currentOnTimeRules={rulesForModeType}
                    handleIsRuleValidChange={(isValid: boolean): void => {
                        handleIsRuleValidChange(currentTab, isValid);
                    }}
                />
            );
        }

        return (
            <Fragment />
        );
    };

    return (
        <PreferenceCard header='Tracking Lost Rule'>
            <Typography component='p' variant='body2'>
                When do you consider a shipment in TRACKING LOST?
            </Typography>

            <ModeTypeTabs currentTab={currentTab} handleTabChange={handleTabChange} />

            {renderTrackingLostRule()}
        </PreferenceCard>
    );
};

export default TrackingLostRuleCard;
